import {DateTime} from 'luxon';

const EMPTY_DATE_VALUE = '0001-01-01T00:00:00';

export default function stringToDateTime(dateTimeString: string): DateTime {
  return dateTimeString === EMPTY_DATE_VALUE || !dateTimeString
    ? null
    : DateTime.fromISO(dateTimeString);
}
